import { useMsal } from "@azure/msal-react";
import Button from "../../../../components/ui/Button";
import Modal, { ModalBody, ModalFooter, ModalFooterChild, ModalHeader } from "../../../../components/ui/Modal";
import { logoutFun } from "../../../../utils/helper";
import {
  GetPictureByContext,
  getAssetByID,
  getAssetIcon,
  getExtraData,
  getExtraDataSchema,
} from "../../../../services/vizyBilityServices";
import { useEffect, useState } from "react";
import Card, { CardBody, CardTitle } from "../../../../components/ui/Card";
import Label from "../../../../components/ui/Label";
import CardSkeleton from "../../../../components/loader/skeleton/cardSkeleton";
import TableSkeletonLoader from "../../../../components/loader/skeleton/tableSkeletonLoader";

const ViewAssetInfoModel = ({ modalStatus, setModalStatus, vieAssetInfoID }) => {
  const { instance, accounts } = useMsal();

  const [isLoading, setIsLoading] = useState(false);
  const [extraLoading, setExtraLoading] = useState(false);
  const [imageLoading, setImageLoading] = useState(false);

  const [assetInfo, setAssetInfo] = useState(null);
  const [images, setImages] = useState([]);
  const [extraDataSchema, setExtraDataSchema] = useState(null);
  const [extraData, setExtraData] = useState({ fields: [] });
  const [assetIcon, setAssetIcon] = useState([]);
  useEffect(() => {
    GetAssetInfoById();
    handleGetAssetIcon();
  }, []);

  const handleGetAssetIcon = () => {
    const header = {
      authorization: `Bearer ${localStorage.getItem("vizy-bility-token")}`,
    };
    getAssetIcon(header, instance, accounts)
      .then((res) => {
        setAssetIcon(res.data);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };
  const GetAssetInfoById = () => {
    setIsLoading(true);
    const header = {
      authorization: `Bearer ${localStorage.getItem("vizy-bility-token")}`,
    };
    const payload = `assetId=${vieAssetInfoID}`;
    getAssetByID(payload, header, instance, accounts)
      .then((res) => {
        setAssetInfo(res.data);
        setIsLoading(false);
        GetExtraData();
        GetExtraDataSchema();
        GetAssetImgs();
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("err", err);
      });
  };

  const GetAssetImgs = () => {
    setImageLoading(true);
    const header = {
      authorization: `Bearer ${localStorage.getItem("vizy-bility-token")}`,
    };
    const query = `context=Asset&contextId=${vieAssetInfoID}`;

    GetPictureByContext(query, header, instance, accounts)
      .then((res) => {
        // setCompanyImg(res.data);

        let ImageList = [];
        res.data?.map((item, index) => {
          ImageList.push({
            ...item,
            New: false,
            preview: item?.url,
            sortCount: index,
          });
        });
        setImages(ImageList);
        setImageLoading(false);
      })
      .catch((err) => {
        setImageLoading(false);
        if (err?.status == 401 || err?.statusText == "Unauthorized") {
          logoutFun(instance);
        }
      });
  };

  const GetExtraDataSchema = async () => {
    setExtraLoading(true);
    const header = {
      authorization: `Bearer ${localStorage.getItem("vizy-bility-token")}`,
    };

    let payload = null;
    if (vieAssetInfoID) {
      payload = `TableName=Asset&PkFieldName=AssetId&PkValue=${vieAssetInfoID}`;
    } else {
      payload = `TableName=Asset`;
    }
    await getExtraDataSchema(payload, header, instance, accounts)
      .then((res) => {
        setExtraDataSchema(res?.data?.[0] || null);
        setExtraLoading(false);
      })
      .catch((err) => {
        setExtraLoading(false);
      });
  };

  const GetExtraData = async () => {
    setExtraLoading(true);
    const header = {
      authorization: `Bearer ${localStorage.getItem("vizy-bility-token")}`,
    };

    let payload = null;
    if (vieAssetInfoID) {
      payload = `TableName=Asset&PkFieldName=AssetId&PkValue=${vieAssetInfoID}`;
    } else {
      payload = `TableName=Asset`;
    }
    await getExtraData(payload, header, instance, accounts)
      .then((res) => {
        setExtraData(res?.data || null);
        setExtraLoading(false);
      })
      .catch((err) => {
        setExtraLoading(false);
      });
  };

  const isLoadingUI = isLoading || extraLoading || imageLoading;
  return (
    <>
      <Modal
        isOpen={modalStatus}
        setIsOpen={setModalStatus}
        isAnimation={true}
        isCentered={true}
        isScrollable={true}
        isStaticBackdrop={"rounded-3xl"}
        size={"lg"}
      >
        <ModalHeader>Asset Information</ModalHeader>

        <ModalBody>
          {isLoadingUI ? (
            <div className="w-[100%]bg-[#00000066] flex justify-center items-center z-50">
              <span class="loader"></span>
            </div>
          ) : (
            <>
              <Card className={"mb-[15px]"}>
                <div className="w-full p-[13px]">
                  <CardTitle>General Info</CardTitle>

                  <CardBody className="mt-[10px] px-[0px]">
                    {/* <div className="p-4 rounded-lg shadow-lg bg-white dark:bg-gray-800"> */}
                    <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                      <div className="flex items-center justify-between p-3 border dark:border-gray-700 rounded-lg bg-gray-50 dark:bg-gray-900 gap-[20px]">
                        <div className="text-gray-600 dark:text-gray-400 font-medium capitalize">Manufacturer</div>
                        <div className="text-gray-900 dark:text-gray-100 font-semibold">
                          {assetInfo?.MakeName || "N/A"}
                        </div>
                      </div>

                      <div className="flex items-center justify-between p-3 border dark:border-gray-700 rounded-lg bg-gray-50 dark:bg-gray-900 gap-[20px]">
                        <div className="text-gray-600 dark:text-gray-400 font-medium capitalize">Model</div>
                        <div className="text-gray-900 dark:text-gray-100 font-semibold">
                          {assetInfo?.Model || "N/A"}
                        </div>
                      </div>

                      <div className="flex items-center justify-between p-3 border dark:border-gray-700 rounded-lg bg-gray-50 dark:bg-gray-900 gap-[20px]">
                        <div className="text-gray-600 dark:text-gray-400 font-medium capitalize">Serial Number</div>
                        <div className="text-gray-900 dark:text-gray-100 font-semibold">
                          {assetInfo?.SerialNumber || "N/A"}
                        </div>
                      </div>

                      <div className="flex items-center justify-between p-3 border dark:border-gray-700 rounded-lg bg-gray-50 dark:bg-gray-900 gap-[20px]">
                        <div className="text-gray-600 dark:text-gray-400 font-medium capitalize">Asset Status</div>
                        <div className="text-gray-900 dark:text-gray-100 font-semibold">
                          {assetInfo?.AssetStatusName || "N/A"}
                        </div>
                      </div>

                      <div className="flex items-center justify-between p-3 border dark:border-gray-700 rounded-lg bg-gray-50 dark:bg-gray-900 gap-[20px]">
                        <div className="text-gray-600 dark:text-gray-400 font-medium capitalize">Year</div>
                        <div className="text-gray-900 dark:text-gray-100 font-semibold">{assetInfo?.Year || "N/A"}</div>
                      </div>

                      <div className="flex items-center justify-between p-3 border dark:border-gray-700 rounded-lg bg-gray-50 dark:bg-gray-900 gap-[20px]">
                        <div className="text-gray-600 dark:text-gray-400 font-medium capitalize">Category</div>
                        <div className="text-gray-900 dark:text-gray-100 font-semibold">
                          {assetInfo?.CategoryName || "N/A"}
                        </div>
                      </div>

                      <div className="flex items-center justify-between p-3 border dark:border-gray-700 rounded-lg bg-gray-50 dark:bg-gray-900 gap-[20px]">
                        <div className="text-gray-600 dark:text-gray-400 font-medium capitalize">Machine Hours</div>
                        <div className="text-gray-900 dark:text-gray-100 font-semibold">
                          {assetInfo?.LastKnownSMU || "N/A"}
                        </div>
                      </div>

                      <div className="flex items-center justify-between p-3 border dark:border-gray-700 rounded-lg bg-gray-50 dark:bg-gray-900 gap-[20px]">
                        <div className="text-gray-600 dark:text-gray-400 font-medium capitalize">
                          Machine Hours As of
                        </div>
                        <div className="text-gray-900 dark:text-gray-100 font-semibold">
                          {assetInfo?.LastSMUDate?.split("T")?.[0] || "N/A"}
                        </div>
                      </div>

                      <div className="flex items-center justify-between p-3 border dark:border-gray-700 rounded-lg bg-gray-50 dark:bg-gray-900 gap-[20px]">
                        <div className="text-gray-600 dark:text-gray-400 font-medium capitalize">Icon</div>
                        <div className="text-gray-900 dark:text-gray-100 font-semibold">
                          {assetInfo?.IconID ? (
                            <img
                              src={assetIcon?.find((item) => item.IconID === assetInfo?.IconID)?.IconURL}
                              className="max-h-[31px] w-auto"
                            />
                          ) : (
                            "N/A"
                          )}
                        </div>
                      </div>

                      <div className="flex items-center justify-between p-3 border dark:border-gray-700 rounded-lg bg-gray-50 dark:bg-gray-900 gap-[20px]">
                        <div className="text-gray-600 dark:text-gray-400 font-medium capitalize">Price</div>
                        <div className="text-gray-900 dark:text-gray-100 font-semibold">
                          {assetInfo?.Price || "N/A"}
                        </div>
                      </div>

                      <div className="flex items-center justify-between p-3 border dark:border-gray-700 rounded-lg bg-gray-50 dark:bg-gray-900 gap-[20px]">
                        <div className="text-gray-600 dark:text-gray-400 font-medium capitalize">
                          Service Meter Units
                        </div>
                        <div className="text-gray-900 dark:text-gray-100 font-semibold">
                          {assetInfo?.Smuunits || "N/A"}
                        </div>
                      </div>

                      <div className="flex items-center justify-between p-3 border dark:border-gray-700 rounded-lg bg-gray-50 dark:bg-gray-900 gap-[20px]">
                        <div className="text-gray-600 dark:text-gray-400 font-medium capitalize">Location</div>
                        <div className="text-gray-900 dark:text-gray-100 font-semibold">
                          {assetInfo?.LocationName || "N/A"}
                        </div>
                      </div>

                      <div className="sm:col-span-1 md:col-span-2 lg:col-span-3 flex items-center justify-start p-3 border dark:border-gray-700 rounded-lg bg-gray-50 dark:bg-gray-900 gap-[10px]">
                        <div className="text-gray-600 dark:text-gray-400 font-medium capitalize">Note</div>
                        <div className="text-gray-900 dark:text-gray-100 font-semibold">
                          {assetInfo?.description || "N/A"}
                        </div>
                      </div>
                    </div>
                    {/* </div> */}
                  </CardBody>
                </div>
              </Card>
              <Card className={"mb-[15px]"}>
                <div className="w-full p-[13px]">
                  <CardTitle>Description</CardTitle>

                  <CardBody className="mt-[10px] px-[0px]">
                    {extraDataSchema?.Schema && (
                      <div className="flex gap-[10px] flex-col">
                        {JSON.parse(extraDataSchema?.Schema || "")
                          ?.fields?.sort((a, b) => Number(a.order) - Number(b.order))
                          .map((item, index) => {
                            return (
                              <div className="flex items-center justify-between p-3 border dark:border-gray-700 rounded-lg bg-gray-50 dark:bg-gray-900">
                                <div className="mb-[20px]">
                                  <div className="text-[16px] font-medium pb-[10px]">{item.label} </div>
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: extraData?.fields?.find(
                                        (extraDataItem) => extraDataItem?.name === item?.name
                                      )?.value,
                                    }}
                                  ></div>
                                </div>
                              </div>
                            );
                          })}
                      </div>
                    )}
                  </CardBody>
                </div>
              </Card>
              <Card className={"mb-[15px]"}>
                <div className="w-full p-[13px]">
                  <CardTitle>Image</CardTitle>
                  {images?.length <= 0 ? (
                    <div className="flex w-full items-center justify-center text-center h-[300px]">
                      <CardTitle>No Image Available</CardTitle>
                    </div>
                  ) : (
                    <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                      {images
                        .sort((a, b) => b.sortCount - a.sortCount)
                        .map((image, index) => (
                          <div
                            key={index}
                            className={`${
                              image?.Main ? "border-[2px] border-[#4BB543]" : ""
                            } relative group border rounded-lg overflow-hidden my-[10px]`}
                          >
                            {/* Image */}
                            <img
                              src={image.preview}
                              alt={`Preview ${index}`}
                              className="w-full h-[170px] object-cover"
                            />
                          </div>
                        ))}
                    </div>
                  )}
                </div>
              </Card>
            </>
          )}
        </ModalBody>

        <ModalFooter className="mt-[20px]">
          <ModalFooterChild></ModalFooterChild>
          <ModalFooterChild>
            <Button
              onClick={() => setModalStatus(false)}
              className="cursor-pointer flex items-center !text-white text-[16px] !bg-[#cb3b41]"
            >
              Close
            </Button>
          </ModalFooterChild>
        </ModalFooter>
      </Modal>
    </>
  );
};
export default ViewAssetInfoModel;
